var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "house-xinfang",
      on: {
        click: function ($event) {
          return _vm.triggleEvent("detail")
        },
      },
    },
    [
      _vm.pic
        ? _c("img", { staticClass: "house-preview", attrs: { src: _vm.pic } })
        : _c("img", {
            staticClass: "house-preview",
            attrs: { src: require("../../images/preview-defalt-new.png") },
          }),
      _vm._v(" "),
      _vm.house.vr_url
        ? _c("img", {
            staticClass: "house-vr",
            attrs: { src: require("../../images/icon-vr.png") },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.house.vedio_url
        ? _c("div", { staticClass: "house-video" }, [_vm._v("视频讲盘")])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "house-yongtu" }, [
        _vm._v(_vm._s(_vm.house.yt)),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "house-info" }, [
        _c("div", { staticClass: "house-title" }, [
          _vm._v(_vm._s(_vm.house.xmmc)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "house-other" }, [
          _vm._v(
            _vm._s(_vm.house.shi) +
              " " +
              _vm._s(_vm.house.pianqu) +
              " 建面" +
              _vm._s(_vm.house.jzmj) +
              "m²"
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "house-price" }, [
          _vm._v(_vm._s(_vm.house.xmjj) + "元/m²"),
        ]),
        _vm._v(" "),
        _vm.biaoqian.length > 0
          ? _c(
              "div",
              { staticClass: "house-tags" },
              _vm._l(_vm.biaoqian, function (tag) {
                return _c("span", { staticClass: "tag" }, [_vm._v(_vm._s(tag))])
              }),
              0
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.house.xmmd
        ? _c("div", { staticClass: "house-md" }, [
            _vm._v("项目卖点：" + _vm._s(_vm.house.xmmd)),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }